import * as moment from 'moment-timezone';

export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'HH:mm';
export const DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
export const DATETIME_WITHOUT_TIMEZONE_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS';

let defaultTimezone: string = moment.tz.guess();

export function setDefaultTimezone(timezone: string): void {
  defaultTimezone = timezone || defaultTimezone;
  moment.tz.setDefault(defaultTimezone);
}

export function getDefaultTimezone(): string {
  return defaultTimezone;
}
